// Avisar que el saldo cambió — ADR-2026-10-29-el-contador-de-creditos-se-entera-solo.
//
// El contador de la sidebar y el de arriba a la derecha en el teléfono (`useCuentaAtlas`,
// `useSaldo`) leen el saldo al cargar y después sólo cuando alguien dispara
// `atlas:credits-updated`. Este módulo lo dispara desde los dos lugares por los que pasa
// casi todo cambio de saldo, en vez de una copia por pantalla:
//
//  • el poll de generaciones (`pollGeneratedByExecutionId`): cada imagen que aparece
//    ya está cobrada, porque el backend la entrega y la cobra en la misma transacción;
//  • volver a la pestaña después de un rato: lo que cambió afuera (otro miembro del
//    equipo, un pago acreditado, otra pestaña) se lee al volver.
//
// Con freno: como mucho un aviso cada `AVISO_MIN_MS`, más uno al final de la ráfaga. Un
// lote de 50 imágenes no dispara 50 relecturas en cada pantalla que escucha.

export const EVENTO_CREDITOS = 'atlas:credits-updated';
export const AVISO_MIN_MS = 3000;
/** Cuánto tiene que haber estado oculta la pestaña para releer el saldo al volver. */
export const AUSENCIA_MIN_MS = 30_000;

let ultimoAviso = -Infinity;
let pendiente: ReturnType<typeof setTimeout> | null = null;

function disparar() {
  ultimoAviso = Date.now();
  try {
    window.dispatchEvent(new Event(EVENTO_CREDITOS));
  } catch {
    /* sin window (tests, SSR): nada que avisar */
  }
}

/** Avisa que el saldo cambió. Si hubo un aviso hace menos de `AVISO_MIN_MS`, lo deja para el final. */
export function avisarCambioDeSaldo(): void {
  if (typeof window === 'undefined') return;
  const espera = AVISO_MIN_MS - (Date.now() - ultimoAviso);
  if (espera <= 0) {
    disparar();
    return;
  }
  if (pendiente) return;
  pendiente = setTimeout(() => {
    pendiente = null;
    disparar();
  }, espera);
}

let instalado = false;

/** Relee el saldo al volver a la pestaña tras `AUSENCIA_MIN_MS` o más. Se instala una vez, en `main.tsx`. */
export function iniciarAvisoAlVolver(): void {
  if (instalado || typeof document === 'undefined') return;
  instalado = true;
  let ocultaDesde: number | null = document.visibilityState === 'hidden' ? Date.now() : null;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      ocultaDesde = Date.now();
      return;
    }
    const estuvoAfuera = ocultaDesde !== null && Date.now() - ocultaDesde >= AUSENCIA_MIN_MS;
    ocultaDesde = null;
    if (estuvoAfuera) avisarCambioDeSaldo();
  });
}

/** Sólo para tests: vuelve el freno a cero. */
export function _reiniciarAvisoDeSaldo(): void {
  if (pendiente) clearTimeout(pendiente);
  pendiente = null;
  ultimoAviso = -Infinity;
  instalado = false;
}
